<template>
  <div id="midialog">
    <v-toolbar flat color="white">
      <v-toolbar-title>Categoría</v-toolbar-title>
      <v-divider
        class="mx-4"
        inset
        vertical
      ></v-divider>
      <div class="flex-grow-1"></div>
      <v-dialog v-model="dialog" persistent>
        <v-form ref="form" v-model="valid">
          <template v-slot:activator="{ on }">
            <!-- se puso transaparent y text para np mostrarlo al hacer render la vista-->
            <v-btn color="transparent" text class="mb-2" v-on="on">Nuevo</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline"> Nueva Categoría</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      v-model="categoria.nombre"
                      label="Nombre"
                      required
                      :rules="[v => !!v || 'Campo requerido']"
                      @input="v => { categoria.nombre = v.toUpperCase() }"
                      ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      v-model="categoria.orden"
                      label="Orden"
                      required
                      :rules="[v => !!v || 'Campo requerido']"
                      ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12">
                    <v-select
                      :items="getAllMaterias"
                      item-text="nombre"
                      item-value="id"
                      label="Materia"
                      persistent-hint
                      return-object
                      v-model="via.materia_id"
                      outlined
                      required
                      :rules="[v => !!v || 'Campo requerido']"
                    >
                    </v-select>
                  </v-col> -->
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-toolbar>

  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      valid: true,
      categoria: {
        nombre: "",
        orden: "",
        activo: 1
      }
    };
  },
  mounted() {
    this.dialog = true;
  },
  // computed: {
  //   ...mapGetters(["getAllMaterias"])
  // },
  // created() {
  //   this.$store.dispatch("GET_ALL_MATERIAS", { url: "materias" });
  // },
  methods: {
    close() {
      this.dialog = false;
      return this.$router.push({ name: "Categorias" });
    },
    save() {
      if (this.$refs.form.validate()) {
        // var materia_id = this.via.materia_id.id
        // this.via.materia_id = materia_id;
        this.$store.dispatch("SAVE_CATEGORIA",  { url: "/categoria", data: this.categoria } ).then(res => {
          this.$swal({
            title: "Exito!!!",
            text: res.data.message,
            icon: 'success',
            confirmButtonText: "Aceptar"
          });
          this.$router.push({ name: "Categorias" });
        })
        .catch(error => {
          this.$swal({
            title: "Error!!!",
            text: error.response.data.message,
            icon: 'warning',
            confirmButtonText: "Aceptar"
          })
        });
      }
    }
  }
};
</script>
